import { UserStore } from '../store/UserStore'
import {
  WeekConsumptionStore,
  IDayConsumption,
} from '../store/WeekConsumptionStore'
import { WeekDays } from '../constants/weekDays'
import uuidv4 from 'uuid/v4'

import { saveDocument } from './kuzzle'

import { ResultStore } from '../store/ResultStore'

/**
 * Generate the 'age6' variable based on the user's age
 * @param age
 */
export const generateAge6 = (age: number) => {
  if (age >= 18 && age <= 24) {
    return 1
  } else if (age > 24 && age <= 34) {
    return 2
  } else if (age > 34 && age <= 44) {
    return 3
  } else if (age > 44 && age <= 54) {
    return 4
  } else if (age > 54 && age <= 64) {
    return 5
  } else if (age > 64 && age <= 75) {
    return 6
  }
}

/**
 * Build Kuzzle Document and save it
 * @param callback
 */
export const saveData = (callback: () => void) => {
  const now = Date.now()
  const nowAsDate = new Date(now)
  const document = {
    id: uuidv4(),
    time: Math.floor(Date.now() / 1000),
    date: `${nowAsDate.getDate()}/${nowAsDate.getMonth() +
      1}/${nowAsDate.getFullYear()}`,
    heure: `${nowAsDate.getHours()}:${
      nowAsDate.getMinutes() < 10
        ? '0' + nowAsDate.getMinutes()
        : nowAsDate.getMinutes()
    }`,
    sexe: UserStore.gender === 'H' ? 1 : 2,
    age: UserStore.age,
    age6: generateAge6(UserStore.age),
    poids: UserStore.weight !== null ? UserStore.weight : 9999,
    nb_jours: UserStore.consumptionDays.length,
  }

  let totalConsumption = 0

  // Do some checks for every day
  WeekDays.forEach((weekDay) => {
    // Build some label since TS refuse to do string access on an object
    const consumptionDayLabel = `conso_${weekDay.label.toLowerCase()}`
    const consumptionCountLabel = `nb_verres_${weekDay.label.toLowerCase()}`

    // Check if the user drank for each day in the UserStore
    if (UserStore.consumptionDays.includes(weekDay.value)) {
      // He did ! Counting the total of glasses drank
      document[consumptionDayLabel] = 1

      WeekConsumptionStore.WeekConsumption.forEach(
        (dayConsumption: IDayConsumption) => {
          // We found the good day
          if (dayConsumption.dayIndex === weekDay.value) {
            document[consumptionCountLabel] =
              dayConsumption.beerCount +
              dayConsumption.cocktailCount +
              dayConsumption.strongAlcoolCount +
              dayConsumption.wineCount

            // add total day consumption to totalWeek
            totalConsumption =
              totalConsumption + document[consumptionCountLabel]
          }
        }
      )
    } else {
      // Good boy ! No drink this day
      document[consumptionDayLabel] = 0
      // This line below is commented because of the condition in the document
      // document[consumptionCountLabel] = 0
    }
  })

  // Fuck you Typescript
  const totalConsumptionKey = 'nb_verres_semaine'
  const priceLabel = 'dep'

  if (UserStore.consumptionDays.length > 0) {
    document[totalConsumptionKey] = totalConsumption
    document[priceLabel] = UserStore.price !== null ? UserStore.price : 9999
  }

  Object.assign(document, {
    rep1: ResultStore.rep1,
    rep2: ResultStore.rep2,
    rep3: ResultStore.rep3,
  })
  document['rep'.toString()] =
    ResultStore.rep1 || ResultStore.rep2 || ResultStore.rep3

  return saveDocument(document)
    .then(() => {
      UserStore.setShowResults(true)
      if (callback) {
        return callback()
      } else {
        return
      }
    })
    .catch((error) => {
      console.error(error)
    })
}



// WEBPACK FOOTER //
// ./src/services/resultHelper.ts